export const DISPLAY_NOTIFICATION = "DISPLAY_NOTIFICATION"
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION"
export const CLEAR_ALL_NOTIFICATIONS = "CLEAR_ALL_NOTIFICATIONS"
export const ADD_NOTIFICATION = "ADD_NOTIFICATION"

export const FETCH_BANKS = 'FETCH_BANKS';
export const FETCH_ROUTES = 'FETCH_ROUTES';
export const FETCH_TERMINAL_TYPES = 'FETCH_TERMINAL_TYPES';
export const FETCH_TERMINAL_APPS = 'FETCH_TERMINAL_APPS';
export const FETCH_BUSINESS_TYPES = 'FETCH_BUSINESS_TYPES';
export const GET_COMMON_DATA = 'GET_COMMON_DATA';